export const PERMISSION_IDS = {
  //Sidebar items
  SEARCH_ACCESS_READ: 'search.access.read',
  HOME_ACCESS_READ: 'home.access.read',
  CLIENTS_ACCESS_READ: 'clients.access.read',
  PARTNERS_ACCESS_READ: 'partners.access.read',
  FORUM_ACCESS_READ: 'forum.access.read',
  DIRECTORIES_ACCESS_READ: 'directories.access.read',
  TOOL_KITS_ACCESS_READ: 'toolkits.access.read',
  TRAININGS_ACCESS_READ: 'trainings.access.read',
  FAQ_ACCESS_READ: 'faq.access.read',
  SETTINGS_ACCESS_READ: 'settings.access.read',
  SETTINGS_TABS_INFO: 'settings.tabs.info',
  SETTINGS_TABS_BIO: 'settings.tabs.bio',
  SETTINGS_TABS_REQUEST_CHANGE: 'settings.tabs.request_change',
  SETTINGS_TABS_ADMIN_ONLY: 'settings.tabs.admin_only',
  SETTINGS_TABS_ADMIN_NOTES: 'settings.tabs.admin_notes',
  SETTINGS_TABS_NOTIFICATIONS: 'settings.tabs.notifications',
  SETTINGS_SECURITY: 'settings.tabs.security',

  //Content items - CRM
  CONTENT_CRM_FORUM_CHANNELS_ACCESS_READ: 'content.crm.forum_channels.access.read',
  CONTENT_CRM_FORUM_CATEGORY_ACCESS_READ: 'content.crm.forum_category.access.read',
  CONTENT_CRM_TOOLKIT_ACCESS_READ: 'content.crm.toolkit.access.read',
  CONTENT_CRM_AGENT_LOCATIONS_ACCESS_READ: 'content.crm.agent_locations.access.read',
  CONTENT_CRM_AGENCY_LIST_ACCESS_READ: 'content.crm.agency_list.access.read',
  CONTENT_CRM_AWARDS_ACCESS_READ: 'content.crm.awards.access.read',
  CONTENT_CRM_NEWSLETTERS_ACCESS_READ: 'content.crm.newsletters.access.read',
  CONTENT_CRM_CATEGORIES_ACCESS_READ: 'content.crm.categories.access.read',
  CONTENT_CRM_GALLERY_ACCESS_READ: 'content.crm.gallery.access.read',
  CONTENT_CRM_LOYALTY_CATEGORIES_ACCESS_READ: 'content.crm.loyalty_categories.access.read',
  CONTENT_CRM_EXPERTISE_ACCESS_READ: 'content.crm.expertise.access.read',

  //Content items - Smartflyer
  CONTENT_SMARTFLYER_HOME_PAGE_CONTENT_ACCESS_READ: 'content.smartflyer.home_page_content.access.read',
  CONTENT_SMARTFLYER_DESTINATION_LIST_ACCESS_READ: 'content.smartflyer.destination_list.access.read',
  CONTENT_SMARTFLYER_CAREER_AT_SMARTFLYER_FORM_ACCESS_READ: 'content.smartflyer.career_at_smartflyer_form.access.read',
  CONTENT_SMARTFLYER_ABOUT_FORM_ACCESS_READ: 'content.smartflyer.about_form.access.read',
  CONTENT_SMARTFLYER_SMARTFLYER_AU_ACCESS_READ: 'content.smartflyer.smartflyer_au.access.read',
  CONTENT_SMARTFLYER_WHAT_WE_DO_FORM_ACCESS_READ: 'content.smartflyer.what_we_do_form.access.read',
  CONTENT_SMARTFLYER_STORY_LIST_ACCESS_READ: 'content.smartflyer.story_list.access.read',
  CONTENT_SMARTFLYER_PRESS_ROOM_ACCESS_READ: 'content.smartflyer.press_room.access.read',
  CONTENT_SMARTFLYER_NEWS_LIST_ACCESS_READ: 'content.smartflyer.news_list.access.read',
  CONTENT_SMARTFLYER_TEAM_ACCESS_READ: 'content.smartflyer.team.access.read',
  CONTENT_SMARTFLYER_AGENT_FRONTEND_SETTINGS_ACCESS_READ: 'content.smartflyer.agent_frontend_settings.access.read',

  CONFIGURATIONS_MENU_ACCESS_READ: 'configurations.menu.access.read',
  CONFIGURATIONS_ROLE_ACCESS_READ: 'configurations.role.access.read',

  SABRE_VIEW_CLIENTS_ACCESS_READ: 'sabreView:view',
  MARKETING_REQUEST_CHANGE_QUEUE_ACCESS_READ: 'marketing.request_change_queue.access.read',
} as const;

export const PERMISSION_PATHS_CONTENT_SOCIETY = [];

export const PERMISSION_PATHS_CONTENT_SMARTFLYER = [];

export const PERMISSION_PATHS_CONTENT = [...PERMISSION_PATHS_CONTENT_SOCIETY, ...PERMISSION_PATHS_CONTENT_SMARTFLYER];

export type PermissionIdsType = (typeof PERMISSION_IDS)[keyof typeof PERMISSION_IDS];
